import React from 'react';
import AudioInput from "../../../widgets/audio-input/AudioInput";

export default (props) => {
    const {
        key,
        name,
        value,
        defaultValue,
        forcedValue,
        data,
        rules,
        options,
        disabled,
        ruleRequired,
        isRequired,
        onChange
    } = props;

    return <AudioInput
        defaultValue={value !== null ? [value] : []}
        onChange={val => onChange(val.length === 0 ? null : val[0])}
        maxFiles={1}
    />;
}
